Directives.TopNavDropdownDirective = function TopNavDropdownDirective() {

    // @ngInject
    function TopNavDropdownDirectiveControllerFunc($scope, $injector, UsersManager,Enums, AbTestService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TopNavDropdownDirectiveController';

        // init
        this.showActivityNotifications = false;
        this.blockElmClass = this.bemClass;
        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
        this.Enums = Enums;
        this.AbTestService = AbTestService;
        this.showToolsBlockWithAnimation = false;

        if (this.shouldBlockTools()) {
            this.showToolsBlockWithAnimation = true;
        }
    }

    var TopNavDropdownDirectiveController = Class(Controllers.BaseController, {
        constructor: TopNavDropdownDirectiveControllerFunc,
        shouldBlockTools: function shouldBlockTools() {
            return this.user.isNetworkPretrialer();
        },
    });

    return {
        scope: {
            show: '=show',
            bemClass: '@?',
            arrowPosition: '@?',
            src:'@'
        },
        transclude: {
            'content': '?dropdownContent'
        },
        templateUrl: 'angular/app/modules/core/features/top_nav/dropdown/top_nav_dropdown_template.html',
        controller: TopNavDropdownDirectiveController,
        controllerAs: 'topNavDropdownVm',
        bindToController: true
    };
};
